import { render, staticRenderFns } from "./toolbarWrapper.vue?vue&type=template&id=2ba0312d&scoped=true&"
import script from "./toolbarWrapper.vue?vue&type=script&lang=js&"
export * from "./toolbarWrapper.vue?vue&type=script&lang=js&"
import style0 from "./toolbarWrapper.vue?vue&type=style&index=0&id=2ba0312d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba0312d",
  null
  
)

export default component.exports